module.exports = __webpack_public_path__ + "img/terroir-choppy-1.e148711b.jpg";